export default __webpack_public_path__ + "static/media/Chamber-Media-Logo-p-800.1fcb37b7.png";